// extracted by mini-css-extract-plugin
export default {"imageWrapper":"aJ-z","twoColumnImage":"bJ-z"};